export default __webpack_public_path__ + "cursor.png";